var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShoppingWhite1212 = function SvgShoppingWhite1212(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.85 8.85a.95.95 0 0 0-.945.95c0 .522.423.95.945.95s.95-.428.95-.95a.953.953 0 0 0-.95-.95m-2.375-7.6a.475.475 0 0 0 0 .95h.159a.5.5 0 0 1 .452.286L3.55 5.574a.5.5 0 0 1-.014.455l-.517.94a.9.9 0 0 0-.119.456c0 .523.428.95.95.95h5.225a.475.475 0 0 0 0-.95H4.05a.12.12 0 0 1-.116-.09.1.1 0 0 1 .004-.056.2.2 0 0 1 .022-.056l.27-.49a.5.5 0 0 1 .438-.258H7.91c.357 0 .67-.195.832-.49l1.7-3.082a.476.476 0 0 0-.418-.703H3.317a.5.5 0 0 1-.452-.287l-.177-.376a.5.5 0 0 0-.452-.287zM8.6 8.85a.95.95 0 0 0-.945.95c0 .522.423.95.945.95.523 0 .95-.428.95-.95a.953.953 0 0 0-.95-.95"
  })));
};
export default SvgShoppingWhite1212;